let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import POS from "../POS.js";
let moment = require('moment');

let main = function ($, _, Backbone, POS) {
    var StatsService = Backbone.Model.extend({
        itemCount : {},
        itemCountLastUpdate: null,
        totalItemSold: 0,
        salesHourMap: {},
        salesHourLastUpdate: null,

        /**
         * return a map containing 24 hour value as key and revenue in that hour as the value.
         * {8: 20, 9: 45, 10: .....}
         *
         */
        getRevenueByHour: function() {
            var self = this;

            if(!this.salesHourLastUpdate) {
                this.salesHourLastUpdate = moment().startOf('day');
            }

            console.log('salesHourMap = ', this.salesHourMap);
            _(_(this.salesHourMap).keys()).each(function(key) {
                self.salesHourMap[key] = 0;
            });

            POS.getBills().each(function (item) {
                var amount, time = new moment(item.get('checkInTime'));

                if(time.isAfter(self.salesHourLastUpdate)) {
                    amount = item.getPaidTotal();

                    if(self.salesHourMap[time.hour()]) {
                        self.salesHourMap[time.hour()] += amount;
                    } else {
                        self.salesHourMap[time.hour()] = amount;
                    }
                }

            });

            return _.clone(this.salesHourMap);
        },

        /**
         * get the total number of item sold since the start of today
         *
         * @returns
         */
        getTotalItemSold: function() {
            if(!this.itemCountLastUpdate) {
                this.getItemCount();
            }

            return this.totalItemSold;
        },

        /**
         * Get the number of item sold form the start of the current day
         * Return a map in the form of [coke: 10, sprite: 5]
         *
         * @param startTime
         * @param endTime
         */
        getItemCount: function() {
            var self = this;

            if(!this.itemCountLastUpdate) {
                this.itemCountLastUpdate = moment().startOf('day');
            }
            self.itemCount = {};
            POS.getBills().each(function(bill) {
                var time = new moment(bill.get('checkInTime'));

                if(time.isAfter(self.itemCountLastUpdate) && bill.get('payStatus')=='Paid') {
                    bill.get('items').each(function(item) {
                        var name = item.get('menuItem').name;
                        if(self.itemCount[name]) {
                            self.itemCount[name] += item.get("quantity");
                        } else {
                            self.itemCount[name] = item.get("quantity");
                        }
                    });

                    self.totalItemSold += bill.get('items').length;
                }
            });

            return _.clone(this.itemCount);
        }
    });

    return new StatsService();
};

let exportedValue = main($, _, Backbone, POS);
export default exportedValue;


// WEBPACK FOOTER //
// ./src/service/StatsService.js